import displayModal from 'root/src/client/logic/modal/actions/displayModal'

export default (modalModuleId, props, modalRouteId) => dispatch => dispatch(
	displayModal(modalModuleId, props, modalRouteId),
)
